import { useCallback } from "react";

import { useTrack } from "@/hooks/useTrack/useTrack";

/**
 * The hook responsible for tracking and notifying for each time the audio changing the playback speed.
 */
export const useTrackAudioSpeed = () => {
  const { track } = useTrack();

  return useCallback(
    (speed: number) => {
      track("playback_speed_changed", { speed_value: String(speed) });
    },
    [track]
  );
};
